export const LOADING_STATIC_USER_PROFILE = 'LOADING_STATIC_USER_PROFILE';
export const LOADING_AUTHENTICATE_USER_DETAILS = 'LOADING_AUTHENTICATE_USER_DETAILS';

export const LOADING_SCREAMS = 'LOADING_SCREAMS';

export const SET_TOKEN_INFO = 'SET_TOKEN_INFO';
export const GET_USER_DATA = 'GET_USER_DATA';
export const UNAUTHENTICATE_USER = 'UNAUTHENTICATE_USER';

export const GET_SCREAMS = "GET_SCREAMS";
export const GET_SINGLE_SCREAM = "GET_SINGLE_SCREAM";
export const MODIFY_LIKE = "MODIFY_LIKE";
export const MODIFY_UNLIKE = "MODIFY_UNLIKE";

export const DELETE_SCREAM = "DELETE_SCREAM";
export const POST_SCREAM = "POST_SCREAM";

export const ADD_COMMENT_TO_SCREAM = "ADD_COMMENT_TO_SCREAM";

export const STATIC_USER_PROFILE = "STATIC_USER_PROFILE";

export const MARK_NOTIFICATIONS_READ = "MARK_NOTIFICATIONS_READ";
